import { EmployeeSection } from '../../components/EmployeeSection';
import { Field, Input, InputPhone } from '@welbe/design-system';
import { useEmployee } from '../../Employee.hooks';
import { Controller } from 'react-hook-form';

export const AccessData = ({ disabled }: { disabled?: boolean }) => {
	const { methods } = useEmployee();
	const { control, register } = methods;

	return (
		<EmployeeSection
			id="access-data"
			title="Accesos"
			description="Correo o teléfono con el que el usuario accederá a sus beneficios"
		>
			<Field.Root readOnly={disabled}>
				<Field.Label>
					Correo de acceso <Field.RequiredIndicator />
				</Field.Label>
				<Input
					type="email"
					placeholder="Escribe el correo de acceso"
					{...register('email')}
				/>
			</Field.Root>

			<Controller
				name="phone"
				control={control}
				render={({ field }) => (
					<InputPhone
						readOnly={disabled}
						value={field.value}
						onChange={(value: any) => {
							field.onChange(value);
						}}
					/>
				)}
			/>
		</EmployeeSection>
	);
};
